import React, { useEffect, useState } from "react";
import StepWizard from "react-step-wizard";
import { BankInfo, BasicInfo, Documents, Plans } from "./add"
import RestaurantTabNav from "../customs/RestaurantTabNav";
import Meals from "./add/meals/Meals";
import { useDispatch } from "react-redux";
import { fetchProfitMargins } from "../../../actions/restaurantAction";
import CustomRadio from "../customs/CustomRadio";


export default function AddRestaurant(props) {
    const [status, setStatus] = useState('Unapproved')
    const dispatch = useDispatch()
    const onRadioSelected = (value) => { setStatus(value) }

    useEffect(() => {
        dispatch(fetchProfitMargins())
    }, [dispatch])

    return (
        <div className="wrapper wrapper-content">
            <div className="ibox">
                <div className="ibox-title">
                    <h5>Add Restaurant</h5>
                </div>
                <div className="ibox-content">
                    <form className="wizard-big">
                        <div className="row justify-content-end mt-2">
                            <CustomRadio
                                values={['Unapproved', 'Active', 'Inactive']}
                                handler={onRadioSelected} />
                        </div>
                        <br />
                        <StepWizard isHashEnabled={true} nav={<RestaurantTabNav {...props} />}>
                            <BasicInfo stepName={"Basic"} hashKey={"basic"} status={status} />
                            <Documents stepName={"Documents"} hashKey={"docs"} />
                            <Meals stepName={"Meals"} hashKey={"meals"} />
                            <Plans stepName={"Plans"} hashKey={"plans"} />
                            <BankInfo stepName={"Bank Info"} hashKey={"bank_info"} />
                        </StepWizard>
                    </form>
                </div>
            </div>
        </div>
    );
}
